import {authFetch} from "./Auth";
import type {
    AddSearchNearTaskResponse,
    AddUserResponse,
    SearchNearTaskSquare, SearchNearTaskPoint,
    TagData
} from "./Types";
import {DateTime} from "luxon";

export function urlQuery(params: Record<string, any>): string {
    return Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&')
}

export async function getTagSuggestions(query: string): Promise<TagData[]> {
    let response = await authFetch('/tags/list', {
        method: 'POST',
        body: JSON.stringify({
            value: query
        })
    })
    if (response.ok) {
        return await response.json()
    } else {
        alert(response.statusText)
    }
}

export async function createTag(tag: TagData) {
    tag.fgStyle = ""
    tag.bgStyle = "secondary"
    let response = await authFetch('/tags/create', {
        method: 'POST',
        body: JSON.stringify(tag),
    })
    if (response.ok) {
        tag.id = (await response.json()).id
    } else {
        alert(response.statusText)
    }
}

export async function addUser(
    phone: string,
    telegram_id: string,
    username: string,
    name: string,
): Promise<AddUserResponse | null> {
    return await addUsers([{telegram_id, phone, username, name}], false)
}

export async function addUsers(users: { phone: string, telegram_id: string, username: string, name: string }[], onlyCheckTelegram: boolean = false): Promise<AddUserResponse | null> {
    let response = await authFetch('/users/add', {
        method: 'POST',
        body: JSON.stringify({
            'users': users,
            'onlyCheckTelegram': onlyCheckTelegram
        })
    })
    if (response.ok) {
        return (await response.json()) as AddUserResponse;
    } else {
        alert(response.statusText)
        return null
    }
}
export async function addSearchNearTask(square: SearchNearTaskSquare): Promise<AddSearchNearTaskResponse | null> {
    let response = await authFetch('/search-near/add-task', {
        method: 'POST',
        body: JSON.stringify({
            'square': square
        })
    })
    if (response.ok) {
        return (await response.json()) as AddSearchNearTaskResponse;
    } else {
        alert(response.statusText)
        return null
    }
}

export enum View {
    full = "full",
    compact = "compact",
}

export enum MessageStatus {
    success = 'Успіх',
    failed = 'Помилка',
    pending = 'В черзі',
}

export enum UserType {
    bot = "Бот",
    deleted = "Видалений",
    regular = "Звичайний",
    unknown = "Невідомо"
}
export enum UserStatus {
    lastMonth = "Місяць тому",
    lastWeek = "Тиждень тому",
    offline = "Офлайн",
    online = "Онлайн",
    recently = "Недавно",
}
export function strToLocaleDateTime(dateTime) {
    if (dateTime == null || dateTime.length < 1) {
        return '';
    }
    return DateTime.fromISO(dateTime).setLocale('ru').toFormat("MM-dd HH:mm");
}export function strToFullLocaleDateTime(dateTime) {
    if (dateTime == null || dateTime.length < 1) {
        return '';
    }
    return DateTime.fromISO(dateTime).setLocale('ru').toFormat("YYYY-MM-dd HH:mm");
}